import React, { useState, useEffect,useRef } from "react";
import { Checkbox, Button } from "@chakra-ui/react";
import { getRoles } from '../../redux/reduxApi/roleReduxApi';
import './User.css';
import { Trash2, SquarePen } from "lucide-react";
import CryptoJS from "crypto-js";
import RoleList from '../../pages/users/RoleList'
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import { toast } from 'react-toastify'
import UserDrawer from "./UserDrawer";
import { FormLabel } from "@chakra-ui/react";
import { Spinner } from "@chakra-ui/react";
import { useDispatch, useSelector } from 'react-redux';
import { deleteRole } from "../../redux/api/rolesApi/RoleApi";
import { deleteRoleAction } from '../../redux/reduxSlice/RoleSlice'
import MobileNav from "../../defaultLayout/MobileNav";
import TeleRolesList from "../crm/lead/leadTeleRoles/TeleRolesList";

function UserRole() {
  const dispatch = useDispatch();
  const [roleData, setRoleData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const getDataRole = useSelector((state) => state.role.role);
  const [isOpen, setIsOpen] = useState(false);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [deleteRoleId, setDeleteRoleId] = useState([]);
  const [RoleROWId, setRoleROWId] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [dataToEdit, setDataToEdit] = useState({});
  const [roleId, setRoleId] = useState()
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const desktopRef = useRef(null);
  const mobileRef = useRef(null);
  const [ismobile, setIsmobile] = useState(false);

  useEffect(() => {
    setRoleData(getDataRole)
  }, [getDataRole]);
  // Get Roles
  useEffect(() => {
    const page = 1;
    // if (loading || currentPage > totalPages) return;
    setLoading(true);
    dispatch(getRoles(page)).then((response) => {
    }).catch((error) => {
      console.log(error)
    }).finally(() => {
      setLoading(false);
      setTimeout(() => {
      }, [300])
    })
  }, []);
  useEffect(() => {
    if (roleData && roleData.length > 0) {
      setData(roleData)
    }
  }, [roleData]);

  // encryption using scret key
  const encryptData = (data) => {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      "secretKey"
    ).toString();
    return encryptedData;
  };
  // dencryption using scret key
  const decryptData = (encryptedData) => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, "secretKey");
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };
  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };
  
  // Handle Delete Function
  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    const idsToDelete = Array.isArray(deleteRoleId) ? deleteRoleId : [deleteRoleId];
    console.log("idsToDelete", idsToDelete)
    Promise.all(idsToDelete.map(id => deleteRole(id)))
      .then(() => {
        setData((prevData) =>
          prevData.filter((item) => !idsToDelete.includes(item?.rowId))
        );
        dispatch(deleteRoleAction(idsToDelete));
        toast.success("Row Deleted successfully");
      })
      .catch((error) => {
        console.log(error);
        toast.success("Row Deleted successfully");

        // toast.error("Row not deleted");
      })
      .finally(() => {
        setShowProgressBar(false);
        setLoading(false);
        closeTrash();
        // setSelectedRows([]);
        setDeleteRoleId([]);
      });
  };
  const openTrash = () => {
    setIsOpen(true)
  }
  // for close Trash Modal
  const closeTrash = () => {
    setIsOpen(false)
  }
  // Single Select
  const handleRowSelect = (ROWID) => {
    const isSelected = selectedRows.includes(ROWID);
    let newSelectedRows = [];

    if (!isSelected) {
      newSelectedRows = [...selectedRows, ROWID];
    } else {
      newSelectedRows = selectedRows.filter(rowRoleId => rowRoleId !== ROWID);
    }
    setSelectedRows(newSelectedRows);
    setRoleROWId(newSelectedRows.join(','));

  };
  // function to check screen size and show hide contente
    const handleResize = () => {
      if (window.innerWidth < 600) {
        mobileRef.current.classList.remove("d-none");
        setIsmobile(true);
      } else {
        mobileRef.current.classList.add("d-none");
        setIsmobile(false);
      }
    };
    useEffect(() => {
      handleResize();
      window.addEventListener("resize", handleResize);
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          </ModalBody>
          <ModalFooter>
            <Button className='create-button' mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className='cancel-button' onClick={closeTrash}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <div>
        {/* tabs starts here */}
        <UserDrawer
          closeDrawer={closeDrawer}
          openDrawer={openDrawer}
          isDrawerOpen={isDrawerOpen}
        />
        <Tabs>
          <TabList>
            <Tab _selected={{ borderBottom: "2px solid rgb(93, 135, 255)" }}>
              {/* Permissions */}Role
            </Tab>
            <Tab _selected={{ borderBottom: "2px solid rgb(93, 135, 255)" }}>
              Users
            </Tab>
            <Tab _selected={{ borderBottom: "2px solid rgb(93, 135, 255)" }}>
              Tele Roles List
            </Tab>
            {/* <Tab _selected={{ borderBottom: "2px solid rgb(93, 135, 255)" }}>
              Data Sharing
            </Tab> */}
          </TabList>
          <TabPanels>
            <TabPanel className="pt-1">
              <div>
                <div className="d-flex justify-content-end align-items-center mb-1">
                  <button className="create-button py-1 px-3" style={{ display: 'block' }} onClick={openDrawer}>
                    Add Role
                  </button>
                </div>
                <div className='custom-scroll ' style={{ height: "70vh" }}>
                  <table class="table">
                    <thead>

                      <tr>
                        <th className="pt-0">Role Name </th>
                        <th className="pt-0">Description</th>
                        <th className="pt-0">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(data) && data.length > 0 ? (
                        data.slice((currentPage - 1) * 30, currentPage * 30).map((item, idx) => (
                          <tr key={idx}>
                            <td>{item?.roleName}</td>
                            <td>{item?.description}</td>
                            <td>
                              <div className="d-flex">
                                {/* <div className="mx-2"> 
                                <i style={{ cursor: 'pointer' }} onClick={(e) => { openTrash(e); setDeleteRoleId(item?.rowId) }} >
                                <Trash2 color="#ff176b" size="16px" strokeWidth="1" />
                              </i></div> */}

                                <div className="mx-2">
                                  {item?.rowId !== "22106000002589586" && ( // Hide Trash icon for this specific rowId
                                    <i style={{ cursor: 'pointer' }} onClick={(e) => { openTrash(e); setDeleteRoleId(item?.rowId); }}>
                                      <Trash2 color="#ff176b" size="16px" strokeWidth="1" />
                                    </i>
                                  )}
                                </div>

                                <div>
                                  <i style={{ cursor: 'pointer' }} onClick={() => {
                                    // console.log("idddd",item)
                                    openDrawer(item); setDataToEdit(item);
                                    setIsUpdateMode(true);
                                    setRoleId(item?.rowId)
                                  }}>
                                    <SquarePen color="#ff176b" size="16px" strokeWidth="1" />
                                  </i></div>
                              </div>

                            </td>

                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2">No roles available</td>
                        </tr>
                      )}
                    </tbody>

                  </table>
                </div>
              </div>
               <div ref={mobileRef}>
                <MobileNav/>
                </div>
            </TabPanel>
           
            <TabPanel className="pt-1">
              <RoleList />
            </TabPanel>
             <TabPanel className="pt-1">
              <TeleRolesList />
            </TabPanel>
             {/* <TabPanel>
              
                <div className="row g-3 mt-2">
                  <div class="col-lg-6 col-md-12 d-flex align-items-stretch">
              <div class="card card-detail p-0">
                      <div class="card-body py-0 pe-0">
                        <div className="mt-5 mb-3">
              <form>
                <div className="row justify-content-center">
                  <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <div className="search-by-title">
                      <input
                        className="rounded"
                        type="text"
                        style={{ outline: "none", border: "none" }}
                        placeholder="Table Name"
                        name="table"
                      />
                    </div>
                    <FormLabel className="small-label ps-3">Table Name </FormLabel>
                  </div>
                </div>
               
                
              </form>
              <div className="row justify-content-center">
                <div className="gap-3 d-flex col-lg-3 col-md-3 col-sm-12 mb-2 ps-5">
                  <button variant="outline" className="cancel-button" mr={3}>
                    Cancel
                  </button>
                  <button className="create-button" >
                    Submit
                  </button>
                </div>
              </div>
              </div>


              </div>  
              </div>
              </div>
              </div>
            </TabPanel> */}
          </TabPanels>
        </Tabs>
        {/* tabs ends here */}
        <UserDrawer RoleROWId={RoleROWId} closeDrawer={closeDrawer} isDrawerOpen={isDrawerOpen} isUpdateMode={isUpdateMode} setIsUpdateMode={setIsUpdateMode} dataToEdit={dataToEdit} roleId={roleId} />

      </div>
    </>
  );
}

export default UserRole;
